import { doFetch } from '../Api/fetch';
import { getConfig } from '../config'
import { CurrentSession } from '../Api/interfaces';

export default class AuthenticationService {
  public async Login(username: string, password: string): Promise<CurrentUser> {
    const serverDefinition = await AuthenticationService.getServerDefinition(username, password);
    if (serverDefinition) {
      const apiUrl = `${serverDefinition.serverLocation}/authentication/login`;
      const user = await this.authorize(username, password, apiUrl);
      if (user) {
        const session: CurrentSession = {
          apiUrl: serverDefinition.serverLocation,
          sessionId: user.SessionId,
          userId: user.UserId,
          webUrl: serverDefinition.appLocation
        }
        localStorage.setItem("metadata", JSON.stringify(session));
        AuthenticationService.OnSessionChanged();
        return user;
      }
    }
    return null;
  }
  public static OnSessionChanged: Function;

  public static cleanSessionInfo() {
    localStorage.removeItem("metadata");
    AuthenticationService.OnSessionChanged();
  }

  public static getSessionInfo(): CurrentSession {
    try {
      const rawMetadata = localStorage.getItem("metadata");
      if (rawMetadata) {
        return JSON.parse(rawMetadata) as CurrentSession;
      }
      return null;
    }
    catch {
      return null;
    }
  }

  private authorize = async (userName: string, password: string, apiUrl: string): Promise<CurrentUser> => {
    const options: RequestInit = {
      method: "POST",
      body: JSON.stringify({ userName, password })
    }
    const response = await doFetch(apiUrl, options) as LogInfo;
    const cu: CurrentUser = {
      SessionId: response.sessionId,
      UserId: response.userId
    };
    return cu;
  }

  public getUser(): Promise<User> {
    const session = AuthenticationService.getSessionInfo();
    if (session) {
      const options: RequestInit = {
        method: "GET",
        headers: {
          Authorization: `Session ${session.sessionId}`,
        }
      }
      const url = `${session.apiUrl}/data/objects/user/${session.userId}?fields=displayname,ImageUrl`;
      return doFetch(url, options);
    }
    return null;
  }

  public static getServerDefinition = async (userName: string, password: string): Promise<ServiceDefinition> => {
    const options: RequestInit = {
      method: "POST",
      body: JSON.stringify({ userName, password })
    }
    const baseUrl = (await getConfig()).serverUrl;
    const url = `${baseUrl}/services/authentication/getServerDefinition`;
    return doFetch(url, options);
  }

  public static getUnAuthorizedServerDefinition = async (): Promise<ServiceDefinition> => {
    const options: RequestInit = {
      method: "POST"
    }
    const baseUrl = (await getConfig()).serverUrl;
    const url = `${baseUrl}/services/authentication/getServerDefinition`;
    return doFetch(url, options);
  }
}

class ServiceDefinition {
  serverLocation: string;
  appLocation: string;
}

class LogInfo {
  sessionId: string;
  userId: string;
}
class User {
  displayname: string;
  ImageUrl: string;
}
class CurrentUser {
  SessionId: string;
  UserId: string;
}